import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@ant-design/v5-patch-for-react-19'

import {
  browserProfilingIntegration,
  browserTracingIntegration,
  init as initSentry,
  replayIntegration,
} from '@sentry/react'

import Root from './providers'

initSentry({
  enabled: import.meta.env.PROD,
  dsn: 'https://3183293fa9bd6aa1384ac3522061d850@o573206.ingest.us.sentry.io/4508845415202816',
  integrations: [browserTracingIntegration(), browserProfilingIntegration(), replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/tochkagp\.com\/graphql/],
  profilesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: import.meta.env.VITE_APP_VERSION,
})

createRoot(document.querySelector('#root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
)
